'use strict';

// todo:
// confirm callerId line fields (for pstn)
// turn off logCommands
// remove developer privileges from equipmentType

var CallsDevice = require('./util/CallsDevice');
var CmdDevice = require('./util/CmdDevice');
var log = require('../../../log/Log').channel('ConvergePro');

var cmdInfo = {
    'mute':                     { type: 'mute',   cfgName: 'mics',               subCfgName: null,     idPropName: null,     filterName: 'mics',                     apiName: 'MUTE' },
    'volume':                   { type: 'volume', cfgName: 'amplifier',          subCfgName: null,     idPropName: null,     filterName: 'amplifier',                apiName: 'GAIN' },
    'assistiveListeningMute':   { type: 'mute',   cfgName: 'assistiveListening', subCfgName: 'mute',   idPropName: null,     filterName: 'assistiveListeningMute',   apiName: 'MUTE' },
    'assistiveListeningVolume': { type: 'volume', cfgName: 'assistiveListening', subCfgName: 'volume', idPropName: null,     filterName: 'assistiveListeningVolume', apiName: 'GAIN' },
    'audioInputMute':           { type: 'mute',   cfgName: 'audioInputSources',  subCfgName: 'mute',   idPropName: 'srcId',  filterName: 'audioInputMute',           apiName: 'MUTE' },
    'audioInputVolume':         { type: 'volume', cfgName: 'audioInputSources',  subCfgName: 'volume', idPropName: 'srcId',  filterName: 'audioInputVolume',         apiName: 'GAIN' },
    'overflowRoomMute':         { type: 'mute',   cfgName: 'overflowRooms',      subCfgName: 'mute',   idPropName: 'roomId', filterName: 'overflowRoomMute',         apiName: 'MUTE' },
    'overflowRoomVolume':       { type: 'volume', cfgName: 'overflowRooms',      subCfgName: 'volume', idPropName: 'roomId', filterName: 'overflowRoomVolume',       apiName: 'GAIN' },
    'soundReinforcementMute':   { type: 'mute',   cfgName: 'soundReinforcement', subCfgName: 'mute',   idPropName: 'zoneId', filterName: 'soundReinforcementMute',   apiName: 'MUTE' },
    'soundReinforcementVolume': { type: 'volume', cfgName: 'soundReinforcement', subCfgName: 'volume', idPropName: 'zoneId', filterName: 'soundReinforcementVolume', apiName: 'GAIN' },
};

var deviceChannelInfo = {
    1: { // 880
        channels: [
            { group: 'O', numbers: [ '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12' ] },
            { group: 'M', numbers: [ '1', '2', '3', '4', '5', '6', '7', '8' ] },
            { group: 'L', numbers: [ '9', '10', '11', '12' ] },
            { group: 'P', numbers: [ 'A', 'B', 'C', 'D', 'E', 'F' ] },
            { group: 'F', numbers: [ '1', '2', '3', '4' ] },
            { group: 'C', numChannels: 255 },
        ],
    },
    2: { // TH20
        channels: [
            { group: 'O', numbers: [ '1', '2' ] },
            { group: 'L', numbers: [ '1', '2' ] },
            { group: 'R', numbers: [ '1' ] },
            { group: 'C', numChannels: 255 },
        ],
    },
    E: { // VH20
        channels: [
            { group: 'O', numbers: [ '1', '2' ] },
            { group: 'L', numbers: [ '1', '2' ] },
            { group: 'Z', numbers: [ '1' ] },
            { group: 'C', numChannels: 255 },
        ],
    },
    3: { // 840T
        channels: [
            { group: 'O', numbers: [ '1', '2', '3', '4', '5', '6', '7', '8', '9' ] },
            { group: 'M', numbers: [ '1', '2', '3', '4' ] },
            { group: 'L', numbers: [ '5', '6', '7', '8' ] },
            { group: 'F', numbers: [ '1', '2', '3', '4' ] },
            { group: 'P', numbers: [ 'A', 'B', 'C', 'D' ] },
            { group: 'R', numbers: [ '1' ] },
            { group: 'C', numChannels: 255 },
        ],
    },
    A: { // 8i
        channels: [
            { group: 'O', numbers: [ '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12' ] },
            { group: 'M', numbers: [ '1', '2', '3', '4', '5', '6', '7', '8' ] },
            { group: 'L', numbers: [ '9', '10', '11', '12' ] },
            { group: 'P', numbers: [ 'A', 'B', 'C', 'D', 'E', 'F' ] },
            { group: 'C', numChannels: 255 },
        ],
    },
    D: { // 880T
        channels: [
            { group: 'O', numbers: [ '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13' ] },
            { group: 'M', numbers: [ '1', '2', '3', '4', '5', '6', '7', '8' ] },
            { group: 'L', numbers: [ '9', '10', '11', '12' ] },
            { group: 'P', numbers: [ 'A', 'B', 'C', 'D', 'E', 'F' ] },
            { group: 'F', numbers: [ '1', '2', '3', '4' ] },
            { group: 'R', numbers: [ '1' ] },
            { group: 'C', numChannels: 255 },
        ],
    },
    H: { // 880TA
        channels: [
            { group: 'O', numbers: [ '1', '2', '3', '4', '5', '6', '7', '8' ] },
            { group: 'M', numbers: [ '1', '2', '3', '4', '5', '6', '7', '8' ] },
            { group: 'J', numbers: [ '1', '2', '3', '4' ] },
            { group: 'L', numbers: [ '9', '10', '11', '12' ] },
            { group: 'P', numbers: [ 'A', 'B', 'C', 'D', 'E', 'F' ] },
            { group: 'R', numbers: [ '1' ] },
            { group: 'C', numChannels: 255 },
        ],
    },
    G: { // SR 1212
        channels: [
            { group: 'O', numbers: [ '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12' ] },
            { group: 'M', numbers: [ '1', '2', '3', '4', '5', '6', '7', '8' ] },
            { group: 'L', numbers: [ '9', '10', '11', '12' ] },
            { group: 'P', numbers: [ 'A', 'B', 'C', 'D', 'E', 'F' ] },
            { group: 'F', numbers: [ '1', '2', '3', '4' ] },
            { group: 'C', numChannels: 255 },
        ],
    },
    I: { // SR 1212A
        channels: [
            { group: 'O', numbers: [ '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12' ] },
            { group: 'M', numbers: [ '1', '2', '3', '4', '5', '6', '7', '8' ] },
            { group: 'L', numbers: [ '9', '10', '11', '12' ] },
            { group: 'J', numbers: [ '1', '2', '3', '4' ] },
            { group: 'P', numbers: [ 'A', 'B', 'C', 'D', 'E', 'F' ] },
            { group: 'C', numChannels: 255 },
        ],
    },
    N: { // Beamforming Mic Array
        channels: [
            { group: 'V', numbers: [ '1' ] },
        ],
    },
    P: { // CONNECT CobraNet
        channels: [ // no channels
        ],
    },
    S: { // CONNECT Dante
        channels: [ // no channels
        ],
    },
};

var gainMax = 20;
var gainMin = -30;
var trimMax = 12;
var trimMin = -12;

var groupType = {
    I: 'input',
    O: 'output',
    M: 'micInput',
    V: 'beamformingMicArray',
    J: 'amplifier',
    G: 'gatingGroup',
    P: 'processing',
    E: 'expansionBus',
    L: 'lineInput',
    A: 'expansionBusReference',
    Y: 'gpio',
    X: 'matrix',
    F: 'fader',
    S: 'preset',
    C: 'macro',
    T: 'pstnTransmit',
    R: 'pstn', // receive
    B: 'virtualReference',
    Q: 'timedEvent',
    W: 'web',
    H: 'paVirtualReference',
    K: 'voipTransmit',
    Z: 'voip', // receive
    D: 'usbTransmit',
    U: 'usbReceive',
};

var suggestedTypes = {};
suggestedTypes.mics = [ 'input', 'micInput', 'lineInput', 'beamformingMicArray', 'processing' ];
suggestedTypes.micsMuteStatus = [ 'input', 'micInput', 'beamformingMicArray', 'processing' ];
suggestedTypes.amplifier = [ 'output', 'amplifier', 'processing' ];
suggestedTypes.assistiveListeningMute = [ 'output', 'amplifier', 'processing' ];
suggestedTypes.assistiveListeningMuteStatus = [ 'output', 'amplifier', 'processing' ];
suggestedTypes.assistiveListeningVolume = [ 'output', 'amplifier', 'processing' ];
suggestedTypes.audioInputMute = [ 'input', 'micInput', 'lineInput', 'processing' ];
suggestedTypes.audioInputMuteStatus = [ 'input', 'micInput', 'lineInput', 'processing' ];
suggestedTypes.audioInputVolume = [ 'input', 'micInput', 'lineInput', 'processing' ];
suggestedTypes.overflowRoomMute = [ 'output', 'amplifier', 'processing' ];
suggestedTypes.overflowRoomMuteStatus = [ 'output', 'amplifier', 'processing' ];
suggestedTypes.overflowRoomVolume = [ 'output', 'amplifier', 'processing' ];
suggestedTypes.soundReinforcementMute = [ 'output', 'amplifier', 'processing' ];
suggestedTypes.soundReinforcementMuteStatus = [ 'output', 'amplifier', 'processing' ];
suggestedTypes.soundReinforcementVolume = [ 'output', 'amplifier', 'processing' ];
suggestedTypes.preset = [ 'macro' ];
suggestedTypes.telephony = [ 'pstn', 'voip' ];

var supportedTypes = {};
supportedTypes.mics = [ 'input', 'micInput', 'lineInput', 'beamformingMicArray', 'fader', 'processing' ];
supportedTypes.micsMuteStatus = [ 'input', 'micInput', 'lineInput', 'beamformingMicArray', 'fader', 'processing' ];
supportedTypes.amplifier = [ 'output', 'amplifier', 'fader', 'processing' ];
supportedTypes.assistiveListeningMute = [ 'input', 'micInput', 'lineInput', 'output', 'amplifier', 'fader', 'processing' ];
supportedTypes.assistiveListeningMuteStatus = [ 'input', 'micInput', 'lineInput', 'output', 'amplifier', 'fader', 'processing' ];
supportedTypes.assistiveListeningVolume = [ 'input', 'micInput', 'lineInput', 'output', 'amplifier', 'fader', 'processing' ];
supportedTypes.audioInputMute = [ 'input', 'micInput', 'lineInput', 'output', 'amplifier', 'fader', 'processing' ];
supportedTypes.audioInputMuteStatus = [ 'input', 'micInput', 'lineInput', 'output', 'amplifier', 'fader', 'processing' ];
supportedTypes.audioInputVolume = [ 'input', 'micInput', 'lineInput', 'output', 'amplifier', 'fader', 'processing' ];
supportedTypes.overflowRoomMute = [ 'input', 'micInput', 'lineInput', 'output', 'amplifier', 'fader', 'processing' ];
supportedTypes.overflowRoomMuteStatus = [ 'input', 'micInput', 'lineInput', 'output', 'amplifier', 'fader', 'processing' ];
supportedTypes.overflowRoomVolume = [ 'input', 'micInput', 'lineInput', 'output', 'amplifier', 'fader', 'processing' ];
supportedTypes.soundReinforcementMute = [ 'input', 'micInput', 'lineInput', 'output', 'amplifier', 'fader', 'processing' ];
supportedTypes.soundReinforcementMuteStatus = [ 'input', 'micInput', 'lineInput', 'output', 'amplifier', 'fader', 'processing' ];
supportedTypes.soundReinforcementVolume = [ 'input', 'micInput', 'lineInput', 'output', 'amplifier', 'fader', 'processing' ];
supportedTypes.preset = [ 'macro' ];
supportedTypes.telephony = [ 'pstn', 'voip' ];

var filtersByGroup = {};
// Build a map of group codes to the suggested filters.
// filtersByGroup = {
//     I: { mics: true, ...
//}
for (var filterName in suggestedTypes) {
    if (!suggestedTypes.hasOwnProperty(filterName)) continue;
    var types = suggestedTypes[filterName];
    /*jshint loopfunc: true */
    types.forEach(function(type) {
        var group = Object.keys(groupType).find(function(key) {
            return groupType[key] === type;
        });

        if (group) {
            CmdDevice.prototype.setNode(filtersByGroup, [group, filterName], true);
        }
    });
}

function ConvergePro(ipAddress, username, password, onConnectStatus,
    onControlStatus, config) {

    this.volume = 0;
    this.volumeMute = true;
    this.mute = false;
    this.assistiveListeningMute = false;
    this.assistiveListeningVolume = 0;
    this.audioInputMute = {};
    this.audioInputVolume = {};
    this.overflowRoomMute = {};
    this.overflowRoomVolume = {};
    this.soundReinforcementMute = {};
    this.soundReinforcementVolume = {};
    this.ringTimeouts = {};
    this.rejectTimeouts = {};

    this.initializeSteps = [{
        state: 'detectingDevices',
        action: (function() {
            this.query('$queryDevices');
            return true;
        }).bind(this),
    }, {
        state: 'finishingInitialization',
        action: (function() {
            this.sendDetected(this.detected);
            this.finishInitialization();
            return true;
        }).bind(this),
    }];

    this.validateSteps = [{
        state: 'queryingValues',
        action: this.queryInitialValues.bind(this),
        getRepeatCount: (function() {
            return this.queryPaths.length;
        }).bind(this),
    }, {
        state: 'queryingTelephony',
        action: this.queryTelephony.bind(this),
        getRepeatCount: (function() {
            return this.callInterfaces.length;
        }).bind(this),
    }, {
        state: 'finishingValidation',
        action: (function() {
            this.finishValidation(this.validated);
            return true;
        }).bind(this),
    }];

    for (var cmdName in cmdInfo) {
        if (!cmdInfo.hasOwnProperty(cmdName)) continue;
        this.commands[cmdName] = this.cmdBuild(cmdName);
    }

    CallsDevice.call(this);
    CmdDevice.call(this, ipAddress, username, password, onConnectStatus,
        onControlStatus, config);
}

ConvergePro.prototype = Object.create(CmdDevice.prototype);
ConvergePro.prototype.constructor = ConvergePro;

Object.assign(ConvergePro.prototype, CallsDevice.prototype);

// The call interface objects will receive these properties from the config:
// * configId
// * deviceType
// * deviceId
// * channelGroup
// * channelNumber
// We also augment the call interface objects with the following properties:
// * receiveGainValue
// * callType
// * name: concatenation of deviceType, deviceId, channelNumber, channelGroup

ConvergePro.prototype.name = 'ConvergePro';
ConvergePro.prototype.key = '-LQjM5pK8TJPVU9cLinv';
ConvergePro.prototype.configName = 'convergeProControlChannels';
ConvergePro.prototype.isAsync = false;
ConvergePro.prototype.rejectAsync = false;
ConvergePro.prototype.syncTimeoutMs = 2000;
ConvergePro.prototype.failOnEmptyConfig = true;
ConvergePro.prototype.sendTerminator = '\r\n';

ConvergePro.prototype.ports = [{
    port: 23,
    verifySend: null,
    verifyConnection: /\* Converge \*/,
    verifyTimeoutMs: 3000,
    loginSkip: null,
    userPrompt: /user:/i,
    userPromptHasNewline: false,
    userPromptTimeoutMs: 1000,
    userDefault: 'clearone',
    userSend: function(value) { return value; },
    passwordPrompt: /pass:/i,
    passwordPromptHasNewline: false,
    passwordPromptTimeoutMs: 1000,
    passwordDefault: 'converge',
    passwordSend: function(value) { return value; },
    loginVerify: /Authenticated/i,
    loginReject: /Invalid User\/Pass/i,
    loginVerifyTimeoutMs: 1000,
}];

// simulationParams are defined at the bottom of the file due to the
// dependency on getDetected

ConvergePro.prototype.commands = {};

ConvergePro.prototype.commands.$callerId = {};
ConvergePro.prototype.commands.$callerId.isAsync = true;
ConvergePro.prototype.commands.$callerId.match = /#(..)\s+XCALLERID\s+(\S+)\s+(\S+)\s+(\S+)\s+(.+)/;
ConvergePro.prototype.commands.$callerId.process = function(match) {
    var name = match[1] + match[2] + match[3];
    var number = match[4].trim();
    var contact = match[5].trim();
    var undef;
    var ci = this.getCallInterfaceByName(name);
    if (ci === null) return;

    if (number === '') number = undef;
    if (contact === '') contact = undef;

    if (!ci.hasOwnProperty('callStatus') &&
        !ci.callStatus.hasOwnProperty('dialString')) {
        this.updateCallerId(ci, number, contact);
    } else {
        this.updateCallerId(ci, undef, contact, number);
    }
 };

ConvergePro.prototype.commands.$queryDevices = {};
ConvergePro.prototype.commands.$queryDevices.activeStates = [ 'initializing' ];
ConvergePro.prototype.commands.$queryDevices.activeInitializeStates = [ 'detectingDevices' ];
ConvergePro.prototype.commands.$queryDevices.isAsync = true;
ConvergePro.prototype.commands.$queryDevices.get = function() {
    this.devices = [];
    this.sendCommand('$queryDevices', '#**VER');
    this.queryDevicesTimeout =
        window.setTimeout(this.onQueryDevicesTimeout.bind(this), 1500);
};
ConvergePro.prototype.commands.$queryDevices.match = /#(.)(.) VER (.+)/;
ConvergePro.prototype.commands.$queryDevices.process = function(match) {
    this.devices.push({
        type: match[1],
        id: match[2],
        version: match[3],
    });
};

ConvergePro.prototype.commands.$ring = {};
ConvergePro.prototype.commands.$ring.isAsync = true;
ConvergePro.prototype.commands.$ring.match = /#(..)\s+RING\s+(\S+)\s+(\S+)|#(..)\s+XRING\s+(\S+)\s+(\S+)\s+(\S+)/;
ConvergePro.prototype.commands.$ring.process = function(match) {
    var name;
    var ringing;

    if (typeof match[1] === 'undefined') {
        name = match[4] + match[5] + match[6];
        ringing = match[7] === '1';
    } else {
        name = match[1] + match[2] + 'R';
        ringing = match[3] === '1';
    }

    if (!ringing) return;
    var ci = this.getCallInterfaceByName(name);
    if (ci === null) return;

    this.setIncomingCall(ci);

    if (this.ringTimeouts.hasOwnProperty(ci.name)) {
        window.clearTimeout(this.ringTimeouts[ci.name]);
    }

    this.ringTimeouts[ci.name] = window.setTimeout((function() {
        if (this.fsm.current === 'controlling') {
            this.disconnectCall(ci);
        }
        delete this.ringTimeouts[ci.name];
    }).bind(this), 7000);
};

ConvergePro.prototype.commands.$telConnect = {};
ConvergePro.prototype.commands.$telConnect.isAsync = true;
ConvergePro.prototype.commands.$telConnect.activeStates =  [ 'validating', 'controlling' ];
ConvergePro.prototype.commands.$telConnect.activeValidateStates = [ 'queryingTelephony' ];
ConvergePro.prototype.commands.$telConnect.match = /#(..)\s+TE\s+(\S+)\s+(\S+)|#(..)\s+XTE\s+(\S+)\s+(\S+)\s+(\S+)/;
ConvergePro.prototype.commands.$telConnect.process = function(match) {
    var name;
    var connected;

    if (typeof match[1] === 'undefined') {
        name = match[4] + match[5] + match[6];
        connected = match[7] === '1';
    } else {
        name = match[1] + match[2] + 'R';
        connected = match[3] === '1';
    }

    var ci = this.getCallInterfaceByName(name);
    if (ci === null) return;

    if (connected) {
        if (!this.rejectTimeouts.hasOwnProperty(name)) {
            this.connectCall(ci);
        }
    } else {
        this.disconnectCall(ci);
    }

    if (this.ringTimeouts.hasOwnProperty(ci.name)) {
        window.clearTimeout(this.ringTimeouts[ci.name]);
        delete this.ringTimeouts[ci.name];
    }
};

ConvergePro.prototype.commands.answer = {};
ConvergePro.prototype.commands.answer.set = function(callId) {
    var ci = this.getCallInterfaceByCallId(callId);

    if (ci === null) {
        log.error(this + ': answer: invalid callId ' + callId);
        return;
    }

    this.answerCall(ci);
    this.sendCommand('$telConnect',
        this.buildCommand(ci.deviceType, ci.deviceId, 'XTE',
            ci.channelNumber, ci.channelGroup, '1'));
};

ConvergePro.prototype.commands.call = {};
ConvergePro.prototype.commands.call.set = function(value) {
    var ci = this.getAvailableCallInterface(value.callType);

    if (ci === null) {
        log.error(this + ': no ' + value.callType + ' resources available');
        return;
    }

    this.placeCall(ci, value.callId, value.dialString);
    this.sendCommand('dial',
        this.buildCommand(ci.deviceType, ci.deviceId, 'XDIAL',
            ci.channelNumber, ci.channelGroup, value.dialString));
};

ConvergePro.prototype.commands.callStatus = {};
ConvergePro.prototype.commands.callStatus.get = function() {
    this.sendCallStatusMessages();
};

ConvergePro.prototype.commands.dial = {};
ConvergePro.prototype.commands.dial.set = function(value) {
    var ci = this.getCallInterfaceByCallId(value.callId);

    if (ci === null) {
        log.error(this + ': dial: invalid callId ' + value.callId);
        return;
    }

    this.sendCommand('dial',
        this.buildCommand(ci.deviceType, ci.deviceId, 'XDIAL',
            ci.channelNumber, ci.channelGroup, value.dialString));
};
ConvergePro.prototype.commands.dial.match = /#(..)\s+XDIAL\s+(\S+)\s+(\S+)\s+(\S+)/;

ConvergePro.prototype.commands.firmwareVersion = {};
ConvergePro.prototype.commands.firmwareVersion.get = function() {
    this.broadcastStatus('firmwareVersion', this.devices[0].version);
};

ConvergePro.prototype.commands.hangup = {};
ConvergePro.prototype.commands.hangup.set = function(callId) {
    var ci = this.getCallInterfaceByCallId(callId);

    if (ci === null) {
        log.error(this + ': hangup: invalid callId ' + callId);
        return;
    }

    this.endCall(ci);
    this.sendCommand('$telConnect',
        this.buildCommand(ci.deviceType, ci.deviceId, 'XTE',
            ci.channelNumber, ci.channelGroup, '0'));
};

ConvergePro.prototype.commands.ping = {};
ConvergePro.prototype.commands.ping.activeStates = [ 'controlling', 'controlFailed' ];
ConvergePro.prototype.commands.ping.get = function() {
    this.sendCommand('ping', this.buildCommand(this.devices[0].type, this.devices[0].id, 'UID'));
};
ConvergePro.prototype.commands.ping.match = /#.. UID (.+)/;

ConvergePro.prototype.commands.receiveGain = {};
ConvergePro.prototype.commands.receiveGain.isAsync = true;
ConvergePro.prototype.commands.receiveGain.activeStates = [ 'validating', 'controlling' ];
ConvergePro.prototype.commands.receiveGain.activeValidateStates = [ 'queryingTelephony' ];
ConvergePro.prototype.commands.receiveGain.set = function(value) {
    var ci = this.getCallInterfaceByCallId(value.callId);

    if (ci === null) {
        log.error(this + ': receiveGain: invalidCallId ' + value.callId);
        return;
    }

    this.updateReceiveGain(ci, value.value);

    this.sendCommand('receiveGain',
        this.buildCommand(ci.deviceType, ci.deviceId, 'GAIN',
            ci.channelNumber, ci.channelGroup, value.value, 'A'));
};
ConvergePro.prototype.commands.receiveGain.match = /#(..)\s+GAIN\s+(\S+)\s+(R|Z)\s+(\S+)/;
ConvergePro.prototype.commands.receiveGain.process = function(match) {
    var name = match[1] + match[2] + match[3];
    var ci = this.getCallInterfaceByName(name);
    if (ci === null) return null;

    this.updateReceiveGain(ci, parseFloat(match[4]));

    if (this.fsm.current === 'validating' &&
        ci.name === this.callInterfaces[this.validateRepeatIndex].name) {
        this.doNextValidateStep();
    }
};

ConvergePro.prototype.commands.reject = {};
ConvergePro.prototype.commands.reject.set = function(callId) {
    var ci = this.getCallInterfaceByCallId(callId);

    if (ci === null) {
        log.error(this + ': reject: invalid callId ' + callId);
        return;
    }

    this.endCall(ci);

    this.sendCommand('$telConnect',
    this.buildCommand(ci.deviceType, ci.deviceId, 'XTE',
        ci.channelNumber, ci.channelGroup, '1'));

    if (this.rejectTimeouts.hasOwnProperty(ci.name)) {
        window.clearTimeout(this.rejectTimeouts[ci.name]);
    }

    this.rejectTimeouts[ci.name] = window.setTimeout((function() {
        delete this.rejectTimeouts[ci.name];

        if (this.getNode(ci, ['callStatus', 'callState']) === 'disconnecting') {
            this.sendCommand('$telConnect',
                this.buildCommand(ci.deviceType, ci.deviceId, 'XTE',
                    ci.channelNumber, ci.channelGroup, '0'));
        }
    }).bind(this), 750);
};

ConvergePro.prototype.commands.volumeMute = {};
ConvergePro.prototype.commands.volumeMute.get = function() {
    this.broadcastStatus('volumeMute', this.volumeMute);
};

ConvergePro.prototype.buildCommand = function(deviceType, deviceId, name, arg1, arg2, arg3, arg4) {
    var cmd = '#' + deviceType + deviceId + ' ' + name;
    if (typeof arg1 !== 'undefined') cmd += ' ' + arg1;
    if (typeof arg2 !== 'undefined') cmd += ' ' + arg2;
    if (typeof arg3 !== 'undefined') cmd += ' ' + arg3;
    if (typeof arg4 !== 'undefined') cmd += ' ' + arg4;
    return cmd;
};

ConvergePro.prototype.cmdBuild = function(cmdName) {
    return {
        isAsync: true,
        activeStates: [ 'validating', 'controlling' ],
        activeValidateStates: [ 'queryingValues' ],
        get: (function() { this.cmdGet(cmdName); }).bind(this),
        set: (function(value) { this.cmdSet(cmdName, value); }).bind(this),
        match: (function(cmd) { return this.cmdMatch(cmdName, cmd); }).bind(this),
        process: (function(value) { return this.cmdProcess(cmdName, value); }).bind(this),
    };
};

ConvergePro.prototype.cmdGet = function(cmdName) {
    var info = cmdInfo[cmdName];

    if (info.idPropName) {
        for (var id in this[cmdName]) {
            if (!this[cmdName].hasOwnProperty(id)) continue;
            var status = { value: this[cmdName][id] };
            status[info.idPropName] = id;
            this.broadcastStatus(cmdName, status);
        }
    } else {
        this.broadcastStatus(cmdName, this[cmdName]);
    }
};

ConvergePro.prototype.cmdMatch = function(cmdName, cmd) {
    var match = this.cmdRegExp.exec(cmd);
    if (match === null) return null;
    var info = cmdInfo[cmdName];
    var cfg;
    var deviceType = match[1];
    var deviceId = match[2];
    var apiName = match[3];
    var channelNumber = match[4];
    var channelGroup = match[5];
    var value = match[6];
    var cfgChannelGroup;

    if (channelGroup === 'M' || channelGroup === 'L') channelGroup = 'I';

    if (apiName !== info.apiName) return null;

    if (info.idPropName) {
        for (var id in this.config[info.cfgName]) {
            if (!this.config[info.cfgName].hasOwnProperty(id)) continue;
            cfg = this.config[info.cfgName][id];
            if (info.subCfgName) cfg = cfg[info.subCfgName];
            if (info.type === 'mute' && cfg.hasOwnProperty('muteStatus')) cfg = cfg.muteStatus;
            cfgChannelGroup = cfg.channelGroup;
            if (cfgChannelGroup === 'M' || cfgChannelGroup === 'L') cfgChannelGroup = 'I';
            if (deviceType === cfg.deviceType &&
                deviceId === cfg.deviceId &&
                channelNumber === cfg.channelNumber &&
                channelGroup === cfgChannelGroup) {
                if (info.type === 'mute') {
                    value = value === '1';
                } else {
                    if (info.cfgName === 'amplifier') {
                        value = (parseFloat(value) - gainMin) * 50 / (gainMax - gainMin);
                    } else {
                        value = (parseFloat(value) - trimMin) * 24 / (trimMax - trimMin) - 12;
                    }

                    value = Math.round(value);
                }

                return { id: id, value: value };
            }
        }
    } else {
        var path = [ info.cfgName ];
        if (info.subCfgName !== null) path.push(info.subCfgName);
        cfg = this.getNode(this.config, path);
        if (cfg === null) return null;
        if (info.type === 'mute' && cfg.hasOwnProperty('muteStatus')) cfg = cfg.muteStatus;
        cfgChannelGroup = cfg.channelGroup;
        if (cfgChannelGroup === 'M' || cfgChannelGroup === 'L') cfgChannelGroup = 'I';
        if (deviceType === cfg.deviceType &&
            deviceId === cfg.deviceId &&
            channelNumber === cfg.channelNumber &&
            channelGroup === cfgChannelGroup) {
            if (info.type === 'mute') {
                return value === '1';
            } else {
                if (info.cfgName === 'amplifier') {
                    value = (parseFloat(value) - gainMin) * 50 / (gainMax - gainMin);
                } else {
                    value = (parseFloat(value) - trimMin) * 24 / (trimMax - trimMin) - 12;
                }

                return Math.round(value);
            }
        }
    }

    return null;
};

ConvergePro.prototype.cmdProcess = function(cmdName, value) {
    var info = cmdInfo[cmdName];

    if (info.idPropName) {
        if (this[cmdName][value.id] !== value.value) {
            this[cmdName][value.id] = value.value;
            var status = { value: value.value };
            status[info.idPropName] = value.id;
            if (this.fsm.current === 'controlling') {
                this.broadcastStatus(cmdName, status);
            }
        }
    } else {
        if (this[cmdName] !== value) {
            this[cmdName] = value;
            if (this.fsm.current === 'controlling') {
                this.broadcastStatus(cmdName, value);
            }
        }
    }

    if (cmdName === 'volume') {
        var newVolumeMute = value === 0;

        if (newVolumeMute !== this.volumeMute) {
            this.volumeMute = newVolumeMute;
            if (this.fsm.current === 'controlling') {
                this.broadcastStatus('volumeMute', this.volumeMute);
            }
        }
    }

    if (this.fsm.current === 'validating') {
        this.doNextValidateStep();
    }
};

ConvergePro.prototype.cmdRegExp = /#(.)(.)\s+(\S+)\s+(\S+)\s+(\S+)\s+(\S+)/;

ConvergePro.prototype.cmdSet = function(cmdName, value) {
    var info = cmdInfo[cmdName];
    var cfg;
    var cmd;

    if (info.idPropName) {
        this[cmdName][value[info.idPropName]] = value.value;
        var status = { value: value.value };
        status[info.idPropName] = value[info.idPropName];
        this.broadcastStatus(cmdName, status);

        cfg = this.config[info.cfgName][value[info.idPropName]];
        if (info.subCfgName) cfg = cfg[info.subCfgName];

        value = value.value;
    } else {
        this[cmdName] = value;
        this.broadcastStatus(cmdName, value);

        cfg = this.config[info.cfgName];
        if (info.subCfgName) cfg = cfg[info.subCfgName];
    }

    if (info.type === 'mute' && cfg.hasOwnProperty('muteStatus')) {
        var macro = value ? cfg.muteMacro : cfg.unmuteMacro;
        cmd = this.buildCommand(macro.deviceType, macro.deviceId, 'MACRO', macro.macroNumber);
    } else {
        var strValue;

        if (info.type === 'mute') {
            strValue = value ? '1' : '0';
        } else {
            if (info.cfgName === 'amplifier') {
                strValue = Math.round(value * (gainMax - gainMin) / 50 + gainMin);
            } else {
                strValue = Math.round((value + 12) * (trimMax - trimMin) / 24 + trimMin);
            }
            strValue += ' A'; // absolute value (vs relative)
        }

        cmd = this.buildCommand(cfg.deviceType, cfg.deviceId, info.apiName, cfg.channelNumber, cfg.channelGroup, strValue);
    }

    this.sendCommand(cmdName, cmd);

    if (cmdName === 'volume') {
        var newVolumeMute = value === 0;

        if (newVolumeMute !== this.volumeMute) {
            this.volumeMute = newVolumeMute;

            if (this.fsm.current === 'controlling') {
                this.broadcastStatus('volumeMute', this.volumeMute);
            }

            cmd = this.buildCommand(cfg.deviceType, cfg.deviceId, 'MUTE',
                cfg.channelNumber, cfg.channelGroup, this.volumeMute ? '1' : '0');
            this.sendCommand(null, cmd);
        }
    }
};

ConvergePro.prototype.findDetectedChannel = function(c) {
    for (var id in this.detected) {
        if (!this.detected.hasOwnProperty(id)) continue;
        var d = this.detected[id];
        if (c.deviceType === d.deviceType &&
            c.deviceId === d.deviceId &&
            c.channelGroup === d.channelGroup &&
            c.channelNumber === d.channelNumber) {
            return d;
        }
    }

    return null;
};

ConvergePro.prototype.getDetected = function(devices) {
    if (typeof devices === 'undefined') devices = this.devices;

    var detected = {};
    var detectedIndex = 0;

    for (var i = 0; i < devices.length; i++) {
        var dev = devices[i];

        for (var j = 0; j < deviceChannelInfo[dev.type].channels.length; j++) {
            var chan = deviceChannelInfo[dev.type].channels[j];
            var filters = filtersByGroup[chan.group];

            if (chan.hasOwnProperty('numbers')) {
                for (var k = 0; k < chan.numbers.length; k++) {
                    detected['a' + detectedIndex] = {
                        deviceType: dev.type,
                        deviceId: dev.id,
                        channelGroup: chan.group,
                        channelNumber: chan.numbers[k],
                        type: groupType[chan.group],
                        filters: filters,
                    };

                    detectedIndex++;
                }
            } else if (chan.hasOwnProperty('numChannels')) {
                detected['a' + detectedIndex] = {
                    deviceType: dev.type,
                    deviceId: dev.id,
                    channelGroup: chan.group,
                    numChannels: chan.numChannels,
                    type: groupType[chan.group],
                    filters: filters,
                };

                detectedIndex++;
            }
        }
    }

    return detected;
};

ConvergePro.prototype.getQueryPaths = function(validated, path, paths) {
    if (typeof path === 'undefined') path = [];
    if (typeof paths === 'undefined') paths = [];

    for (var key in validated) {
        if (!validated.hasOwnProperty(key)) continue;
        if (path.length === 0 && key === 'telephony') continue;

        if (typeof validated[key] === 'string') {
            if (validated[key] === 'ok') {
                paths.push(path.concat(key));
            }
        } else {
            this.getQueryPaths(validated[key], path.concat(key), paths);
        }
    }

    return paths;
};

ConvergePro.prototype.onComputeCaps = function() {
    var caps = this.getCapsTemplate();
    this.computeCapsFromConfig(caps);
    this.computeCapsMaxCalls(caps);
    caps.hasFirmwareVersion = true;
    caps.hasRoomVolumeMute = caps.hasRoomVolume;
    return caps;
};

ConvergePro.prototype.onDestroy = function() {
    var name;

    for (name in this.ringTimeouts) {
        if (!this.ringTimeouts.hasOwnProperty(name)) continue;
        window.clearTimeout(this.ringTimeouts[name]);
    }

    this.ringTimeouts = {};

    for ( name in this.rejectTimeouts) {
        if (!this.rejectTimeouts.hasOwnProperty(name)) continue;
        window.clearTimeout(this.rejectTimeouts[name]);
    }

    this.rejectTimeouts = {};

    CallsDevice.prototype.onDestroy.call(this);
};

ConvergePro.prototype.onInitialize = function() {
    this.startInitializer();
};

ConvergePro.prototype.onValidate = function() {
    this.validated = {};

    for (var cmdName in cmdInfo) {
        if (!cmdInfo.hasOwnProperty(cmdName)) continue;
        this.validateConfig(this.validated, cmdName, cmdInfo[cmdName]);
    }

    this.validateConfig(this.validated, 'foo', { type: 'telephony', cfgName: 'telephony', subCfgName: null, idPropName: 'foo', filterName: 'telephony', apiName: 'foo' });

    for (var i = 0; i < this.callInterfaces.length; i++) {
        var ci = this.callInterfaces[i];
        ci.receiveGainValue = 0;
        ci.callType = ci.channelGroup === 'R' ? 'pstn' : 'voip';
        ci.name = ci.deviceType + ci.deviceId + ci.channelNumber + ci.channelGroup;
    }

    for (var id in this.config.telephony) {
        if (!this.config.telephony.hasOwnProperty(id)) continue;
        if (this.getNode(this.validated, ['telephony', id]) !== 'ok') {
            var cfg = this.config.telephony[id];
            this.removeCallInterfaceByName(cfg.deviceType + cfg.deviceId +
                cfg.channelNumber + cfg.channelGroup);
        }
    }

    this.queryPaths = this.getQueryPaths(this.validated);
    this.startValidator();
};

ConvergePro.prototype.queryInitialValues = function() {
    var path = this.queryPaths[this.validateRepeatIndex];
    var cfg = this.getNode(this.config, path);

    if (cfg.hasOwnProperty('muteStatus')) cfg = cfg.muteStatus;

    var cmdName;
    var found = false;

    for (cmdName in cmdInfo) {
        if (!cmdInfo.hasOwnProperty(cmdName)) continue;
        var i = cmdInfo[cmdName];
        var n = i.idPropName === null ? 1 : 2;
        if (i.cfgName === path[0] && (i.subCfgName === null || i.subCfgName === path[n])) {
            found = true;
            break;
        }
    }

    if (!found) {
        log.error(this + ': error computing value to query: path = ' +
            JSON.stringify(path) + ', cfg = ' + JSON.stringify(cfg));
        this.defer(this.doNextValidateStep.bind(this));
        return;
    }

    var info = cmdInfo[cmdName];
    var cmd = this.buildCommand(cfg.deviceType, cfg.deviceId, info.apiName,
        cfg.channelNumber, cfg.channelGroup);
    this.sendCommand(cmdName, cmd);
    return true;
};

ConvergePro.prototype.queryTelephony = function() {
    var ci = this.callInterfaces[this.validateRepeatIndex];

    this.sendCommand('$telConnect',
        this.buildCommand(ci.deviceType, ci.deviceId, 'XTE',
            ci.channelNumber, ci.channelGroup));

    this.sendCommand('receiveGain',
        this.buildCommand(ci.deviceType, ci.deviceId, 'GAIN', ci.channelNumber, ci.channelGroup));

    return true;
};

ConvergePro.prototype.onQueryDevicesTimeout = function() {
    this.queryDevicesTimeout = null;

    if (this.fsm.current === 'initializing') {
        log.debug(this + ': detected ' + this.devices.length + ' devices: ' +
            JSON.stringify(this.devices, null, 4));
        this.detected = this.getDetected();
        if (this.devices.length > 0) this.doNextInitializeStep();
    }
};

ConvergePro.prototype.validateChannel = function(info, cfg) {
    if (this.findDetectedChannel(cfg) !== null) {
        if (supportedTypes[info.filterName].includes(groupType[cfg.channelGroup])) {
            return 'ok';
        } else {
            return 'invalidChannel';
        }
    }

    return 'noChannel';
};

ConvergePro.prototype.validateMacro = function(cfg) {
    for (var id in this.detected) {
        if (!this.detected.hasOwnProperty(id)) continue;
        var d = this.detected[id];

        if (d.channelGroup === 'C' &&
            cfg.deviceType === d.deviceType &&
            cfg.deviceId === d.deviceId) {
            if (cfg.macroNumber > 0 && cfg.macroNumber <= d.numChannels) {
                return 'ok';
            } else {
                return 'invalidChannel';
            }
        }
    }

    return 'noChannel';
};

ConvergePro.prototype.validateConfig = function(validated, cmdName, info) {
    var cfg;
    var path;
    var result;

    if (info.idPropName) {
        this[cmdName] = {};

        for (var id in this.config[info.cfgName]) {
            if (!this.config[info.cfgName].hasOwnProperty(id)) continue;

            this[cmdName][id] = info.type === 'mute' ? false : 0;
            path = info.subCfgName ?
                [info.cfgName, id, info.subCfgName] : [info.cfgName, id];
            cfg = this.getNode(this.config, path);
            if (cfg === null) continue;

            if (info.type === 'mute' && cfg.hasOwnProperty('muteStatus')) {
                result = this.validateMuteMacroConfig(info, cfg);
            } else {
                result = this.validateChannel(info, cfg);

                if (result === 'ok' &&
                    this.duplicateExists(id, this.config[info.cfgName], info.subCfgName)) {
                    result = 'duplicateChannel';
                }
            }

            this.setNode(validated, path, result);
        }
    } else {
        this[cmdName] = info.type === 'mute' ? false : 0;

        if (!this.config.hasOwnProperty(info.cfgName)) return;
        if (info.subCfgName && !this.config[info.cfgName].hasOwnProperty(info.subCfgName)) return;

        cfg = info.subCfgName ?
            this.config[info.cfgName][info.subCfgName] : this.config[info.cfgName];
        path = info.subCfgName ? [info.cfgName, info.subCfgName] : [info.cfgName];
        result = info.type === 'mute' && cfg.hasOwnProperty('muteStatus') ?
            this.validateMuteMacroConfig(info, cfg) :
            this.validateChannel(info, cfg);
        this.setNode(validated, path, result);
    }
};

ConvergePro.prototype.validateMuteMacroConfig = function(info, cfg) {
    var muteMacroValidated = this.validateMacro(cfg.muteMacro);
    var unmuteMacroValidated = this.validateMacro(cfg.unmuteMacro);
    var muteStatusValidated = this.validateChannel(info, cfg.muteStatus);

    if (muteMacroValidated === 'noChannel' ||
        unmuteMacroValidated === 'noChannel' ||
        muteStatusValidated === 'noChannel') {
        return 'noChannel';
    }

    if (muteMacroValidated === 'invalidChannel' ||
        unmuteMacroValidated === 'invalidChannel' ||
        muteStatusValidated === 'invalidChannel') {
        return 'invalidChannel';
    }

    return 'ok';
};

ConvergePro.prototype.simulationParams = {
    caps: {
        hasAssistiveListening: true,
        hasAudioInputSourcesMute: true,
        hasFirmwareVersion: true,
        hasRoomMute: true,
        hasRoomVolume: true,
        hasRoomVolumeMute: true,
        hasOverflowRoomsMute: true,
        hasSoundReinforcement: true,
        maxCalls: {
            pstn: 0,
            video: 0,
            voip: 1,
        },
    },
    callHasReceiveGain: function(ci, config, detected) {
        return true;
    },
    detected: ConvergePro.prototype.getDetected([
        { type: '1', id: '0', version: '4.4.0.30', },
        { type: 'E', id: '0', version: '4.4.0.30', },
    ]),
    firmwareVersion: '4.4.0.30',
    channelsAreEqual: function(a, b) {
        return a.deviceType === b.deviceType &&
            a.deviceId === b.deviceId &&
            a.channelNumber === b.channelNumber &&
            a.channelGroup === b.channelGroup &&
            a.macroNumber === b.macroNumber;
    },
    channelMatchesDetected: function(chan, det) {
        if (chan.hasOwnProperty('muteStatus')) {
            chan = chan.muteStatus;
        }

        return chan.deviceType === det.deviceType &&
            chan.deviceId === det.deviceId &&
            chan.channelGroup === det.channelGroup &&
            (chan.hasOwnProperty('channelNumber') &&
             chan.channelNumber === det.channelNumber ||
             chan.hasOwnProperty('macroNumber') &&
             chan.macroNumber <= det.numChannels);
    },
    getTelephonyType: function(cfg, detected) {
        return cfg.channelGroup === 'Z' ? 'voip' : 'pstn';
    },
};

module.exports = ConvergePro;
